export const GET_AUTO_SUGGESTION = 'GET_AUTO_SUGGESTION';
export const SUGGESTION_SEARCH = 'SUGGESTION_SEARCH';
export const FULL_SEARCH = 'FULL_SEARCH';
